<template>
    <div class="profile-index">
        <p class="profile-index__text">
            {{ $t('Manage your personal information.') }}
        </p>
        <div class="row">
            <div class="col-md-12">
                <dashboard-profile-card>
                    <profile-picture-selector class="d-none" />
                    <personal-information-card :account="account"/>
                    <change-contact-info-card :account="account" @accountInformationUpdated="accountUpdated"/>
                </dashboard-profile-card>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardProfileCard from '@/components/profile/DashboardProfileCard.vue';
import PersonalInformationCard from '@/components/profile/PersonalInformationCard.vue';
import ProfilePictureSelector from '@/components/profile/ProfilePictureSelector.vue';
import ChangeContactInfoCard from '@/components/profile/ChangeContactInfoCard.vue';

export default {
    name: 'ProfileIndex',
    components: {
        DashboardProfileCard,
        PersonalInformationCard,
        ProfilePictureSelector,
        ChangeContactInfoCard
    },
    data() {
        return {
            account: {},
            loadingAccount: false,
        };
    },
    mounted() {
        this.getAccount();
    },
    methods: {
        async getAccount() {
            this.loadingAccount = true;

            try {
                const { data } = await this.axiosAccount.get('/api/accounts/me');

                this.account = data;
            } catch (error) {
                this.showError(error);
            } finally {
                this.loadingAccount = false;
            }
        },
        accountUpdated(account) {
            this.account = account;
        },
    },
};
</script>
